module.exports = __webpack_public_path__ + "static/media/YF14_4.9e09209e.jpg";